// Module
var code = `<h2 class="section-header">Please confirm the following:</h2>
<form name="\$ctrl.form">
  <table class="table">
    <tbody>
    <tr>
      <td>Mode:</td>
      <td>
        <select
                ng-model="\$ctrl.manualMetadata"
                ng-options="o.value as o.label for o in \$ctrl.loanMetadata"
                required>
        </select>
      </td>
    </tr>
    <tr>
      <td>Content:</td>
      <td>
        <file-upload
          ng-model="\$ctrl.contentFile"
          required
          validate-uploaded
          max-files="1"
          show-file-name="true"
          show-remarks="false"
          enable-webcam="false">
        </file-upload>
      </td>
    </tr>
    </tbody>
  </table>

  <div class="summary-actions">
    <button
      type="button"
      class="btn btn-info"
      ng-click="\$ctrl.downloadSampleFile()">
      Download sample file
    </button>
    <button
      type="submit"
      class="btn btn-success"
      ng-disabled="\$ctrl.form.\$invalid"
      ng-click="\$ctrl.execute()">
      Execute
    </button>
  </div>
</form>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/support/misc/update-loan-metadata-mode/update-loan-metadata-mode.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;